import { mapGetters, mapActions } from 'vuex'
import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import ReportSchedule from '@/models/report-schedule'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import BtnIcon from '@/components/button/BtnIcon'
import Row from '../Row/Bundle'

export default {
  components: {
    BtnIcon,
    Row
  },
  mixins: [
    pageLoading,
    pageTitle,
  ],
  title () {
    return this.$t("text.imageDiagnosis")
  },
  props: {
    repository: Object
  },
  data () {
    return {
      reportSchedules: [],
    }
  },
  watch: {
    reportSchedules (value) {
      this.$store.commit('report/setUnanswerCount', value.filter(e => !e.isAnswered).length)
    }
  },
  mounted () {
    this.clearToolbarTitle()
    this.fetchData()
  },
  methods: {
    ...mapActions([
      'clearToolbarTitle',
    ]),
    tabPrev () {
      this.$router.push({ name: "matching-index" })
    },
    onAnswer (reportSchedule) {
      this.$router.push({
        name: "reportSchedule-show",
        params: { id: reportSchedule.id }
      })
    },
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.get())
        this.reportSchedules = plainToClass(ReportSchedule, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
  }
}
